import ChatTypes from "../../enums/ChatTypes";

export default {
    directsRoomsUsers: state => {
        const result = [];
        state.list.forEach((item) => {
            if (item.type == ChatTypes.direct && item.userId && item.isHidden == false) {
                result.push(item.userId);
            }
        });
        return result;
    },
    roomById: state => (roomId) => {
        let room = state.list.find(item => item.id == roomId);
        if (!room) {
            room = state.removed.find(item => item.id == roomId);
        }
        return room;
    },
    unreadCount: (state) =>  {
        let res = 0;
        state.list.forEach((item) => {
            res += (item.unreadCount ? 1 : 0);
        });
        return res;
    }
}